import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OMPLIR_ESTACIO_SELECCIONADA } from '../../../actions/actionTypes';

//TODO: modificar quan s'implementi la visualitzacio
export const ESTAT_INICIAL = null;

const idEstacioSeleccionada = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OMPLIR_ESTACIO_SELECCIONADA:
            return action.idEstacioSeleccionada;

        default:
            return state;
    }
};

export default idEstacioSeleccionada;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/idEstacioSeleccionada.js